<template>
  <div className="animated">
    <b-card class="animated fadeIn">
      <b-card-body>
        <b-modal
          ref="infoModal"
          centered
          size="xl"
          title="Reporte de proceso"
          @ok="closeModal"
          ok-only
        >
          <div class="text-center">
            <b-spinner v-if="loading" label="Spinning"></b-spinner>
          </div>
          <component :is="report" :process="process" ref="report"></component>
        </b-modal>

        <b-modal
          ref="infoModalRepa"
          centered
          size="xl"
          title="Reporte de repaletizaje"
          @ok="closeModal"
          ok-only
        >
          <component
            :is="componenteActual"
            :process="tableDataPalletIn"
            :tableDataMovimientos="tableDataMovimientos"
            ref="ReportRepaletizaje"
          ></component>
        </b-modal>

        <h1>Procesos</h1>
        <div>
          <b-form>
            <b-row>
              <b-col>
                <label for="monthSelect">Seleccione mes</label>
                <b-form-select
                  id="monthSelect"
                  v-model="selected.month"
                  :plain="true"
                  :options="selectOptions.months"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <b-col>
                <label for="yearSelect">Año</label>
                <b-form-select
                  id="yearSelect"
                  v-model="selected.year"
                  :plain="true"
                  :options="selectOptions.years"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <b-col>
                <label for="productSelect">Seleccione exportadora</label>
                <b-form-select
                  id="productSelect"
                  v-model="selected.client_customer"
                  :plain="true"
                  :options="selectOptions.client_customers"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label for="conditionSelect">Seleccione planta</label>
                <b-form-select
                  id="conditionSelect"
                  v-model="selected.plant"
                  :plain="true"
                  :options="selectOptions.plants"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <b-col>
                <label for="productTypeSelect"
                  >Seleccione tipo de proceso</label
                >
                <b-form-select
                  id="productTypeSelect"
                  v-model="selected.process_type"
                  :plain="true"
                  :options="selectOptions.process_types"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <b-col>
                <label for="processStatusSelect">Seleccione estado</label>
                <b-form-select
                  id="processStatusSelect"
                  v-model="selected.process_status"
                  :plain="true"
                  :options="selectOptions.process_statuses"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
            </b-row>
          </b-form>
        </div>
        <hr />
        <v-server-table
          :url="url"
          :columns="columns"
          :options="options"
          :theme="theme"
          ref="table"
          id="dataTable"
        >
          <template slot="process_status" slot-scope="props">
            <div style="text-align: center">
              <b-badge pill :variant="getBadge(props.row.process_status)">{{
                status(props.row.process_status)
              }}</b-badge>
            </div>
          </template>
          <template slot="afterFilter">
            <tr v-if="loading" class="VueTables__no-results">
              <b-spinner
                v-if="loading"
                variant="primary"
                class="ml-2 mt-1"
                small
                label="Small Spinner"
              ></b-spinner>
            </tr>
          </template>
          <div slot="beforeLimit">
            <download-excel
              class="btn"
              :fetch="fetchData"
              :fields="json_fields"
              worksheet="Procesos"
              :name="name"
              :before-generate="startDownload"
              :before-finish="finishDownload"
            >
              <b-link>Descargar</b-link>
            </download-excel>
          </div>
          <template slot="child_row" scope="props">
            <div><b>Fecha/Hora de inicio:</b> {{ props.row.start_time }}</div>
            <div><b>Fecha/Hora de término:</b> {{ props.row.end_time }}</div>
            <div>
              <b>Planta: </b>{{ props.row.process_room.plant.name }}({{
                props.row.process_room.plant.plant_code
              }}), procesado en {{ props.row.process_room.name }}, en el turno
              {{ props.row.shift.name }}, supervisado por
              {{ props.row.shift_supervisor.first_name }}
              {{ props.row.shift_supervisor.last_name }}
            </div>
            <div><b>Notas:</b> {{ props.row.note }}</div>
          </template>
          <div slot="total_kilograms" slot-scope="props">
            <div style="text-align: right">
              {{ props.row.total_kilograms.format("0,0.00") }}
            </div>
          </div>
          <div slot="percentage_exportable" slot-scope="props">
            <div style="text-align: right">
              {{ props.row.percentage_exportable.format("0,0.00") }} %
            </div>
          </div>
          <div slot="duration" slot-scope="props">
            <div style="text-align: right">{{ props.row.duration }}</div>
          </div>
          <div slot="number" slot-scope="props">
            <div style="text-align: right">{{ props.row.number }}</div>
          </div>
          <div slot="process_date" slot-scope="props">
            <div style="text-align: right">{{ props.row.process_date }}</div>
          </div>
          <div slot="shift_workers" slot-scope="props">
            <div style="text-align: right">{{ props.row.shift_workers }}</div>
          </div>
          <div slot="source_documents" slot-scope="props">
            <template v-for="it in props.row.source_documents">
              <a href="#" @click.prevent="getCompleteWaybill(it.id)">
                {{ it.number }}
              </a>
            </template>
          </div>
          <div class="text-right" slot="actions" slot-scope="props">
            <!--  <a v-if="props.row.process_status === 2" target="_blank" href="#" @click.prevent="sendEmail(props.row.id)" class="fa fa-lg fa-send text-primary"></a>&nbsp; -->
            <a
              target="_blank"
              href="#"
              @click.prevent="
                showProcessModal(
                  props.row.id,
                  props.row.process_type.process_option
                )
              "
              class="fa fa-lg fa-search text-primary"
            ></a
            >&nbsp;
            <a
              v-if="props.row.process_status === 2"
              target="_blank"
              href="#"
              @click.prevent="authorizationUser(props.row, emailModal)"
              class="fa fa-lg fa-send text-primary"
            ></a
            >&nbsp;
            <a
              target="_blank"
              href="#"
              @click.prevent="authorizationUser(props.row, editProcess)"
              class="fa fa-lg fa-edit text-primary"
            >
            </a
            >&nbsp;
          </div>
        </v-server-table>
      </b-card-body>
    </b-card>

    <email-modal
      :to="to"
      :cc="cc"
      :bcc="bcc"
      :process_id="process_id"
      :process_type_option="process_type_option"
      :type="2"
      :subject="subject"
      :msg="msg"
      ref="email"
    >
    </email-modal>

    <authorization-modal
      v-if="this.methodDynamic != null"
      :modal="Modalauthorization"
      :obj="currentObj"
      @hideAuthorizationModal="hideAuthorizationModal"
      v-on="{ methodDynamic: methodDynamic }"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import Report from "./Report2.vue";
import WaybillReport from "../recepcion/Report.vue";
import ReportRepaletizaje from "./ImprimirRepaletizaje.vue";
import emailModal from "../reusable/emailModal";
import authorizationModal from "../reusable/authorizationModal";

numeral.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(VueNotifications);
Vue.use(miniToastr);

export default {
  name: "DataTable",
  components: {
    ServerTable,
    Report,
    WaybillReport,
    ReportRepaletizaje,
    emailModal,
    authorizationModal
  },
  created() {
    this.getSelectionSet();
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });

    this.loadYear();
  },
  data() {
    return {
      waybill: null,
      process_id: null,
      process_type_option: null,
      report: "",
      loading: false,
      process: [],
      componenteActual: "",
      tableDataPalletIn: [],
      tableDataMovimientos: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Exportadora: "client_customer.name",
        Huerto: "origin_name",
        "Tipo Proceso": "process_type.name",
        Numero: "number",
        Guias: {
          field: "source_documents",
          callback: (value) => {
            return Array.prototype.map.call(value, (s) => s.number).toString();
          }
        },
        "Fecha Proceso": "process_date",
        Trabajadores: "shift_workers",
        Estatus: "process_status",
        Duración: "duration",
        "Total Volteado": {
          field: "total_kilograms",
          callback: (value) => {
            return numeral(value).format("0.00");
          }
        },
        Porcentaje: {
          field: "percentage_exportable",
          callback: (value) => {
            return numeral(value).format("0.00");
          }
        }
      },
      columns: [
        "client_customer.name",
        "origin_name",
        "process_type.name",
        "number",
        "source_documents",
        "process_date",
        "shift_workers",
        "process_status",
        "duration",
        "total_kilograms",
        "percentage_exportable",
        "actions"
      ],
      selected: {
        client_customer: "",
        process_type: "",
        plant: "",
        month: d.getMonth() + 1,
        process_status: "",
        year: d.getFullYear()
      },
      selectOptions: {
        client_customers: [{ value: "", text: "-----------" }],
        process_types: [{ value: "", text: "-----------" }],
        plants: [{ value: "", text: "-----------" }],
        process_statuses: [
          { value: "", text: "-----------" },
          { value: "1", text: "Abierto" },
          { value: "2", text: "Cerrado" }
        ],
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].process_date = moment(
              results[key].process_date
            ).format("DD-MM-YYYY");
            results[key].total_kilograms = numeral(
              parseFloat(results[key].total_kilograms)
            );
            results[key].percentage_exportable = numeral(
              parseFloat(results[key].percentage_exportable)
            );
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        debounce: 800,
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        // columnsDropdown: true,
        filterByColumn: false,
        headings: {
          "client_customer.name": "Exportadora",
          "process_type.name": "Tipo",
          number: "Número",
          process_date: "Fecha Proceso",
          shift_workers: "Trabajadores",
          source_documents: "Guias",
          process_status: "Estatus",
          duration: "Duracion",
          total_kilograms: "Kg Volteados",
          origin_name: "Huerto",
          percentage_exportable: "Porcentaje",
          actions: "Acciones"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      to: null,
      cc: null,
      bcc: null,
      subject: null,
      msg:
        "Estimado Productor, \n" +
        "Nos es grato informarle que hemos procesado su fruta. Por favor revise en archivo adjunto los detalles del proceso.\n" +
        "\n" +
        "Atte.,",
      Modalauthorization: false,
      currentObj: null,
      methodDynamic: null
    };
  },
  computed: {
    name() {
      return "Procesos " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },

    url() {
      return (
        "/api/v1/process/detailed/?" +
        "process_type=" +
        this.selected.process_type +
        "&process_room__plant=" +
        this.selected.plant +
        "&client_customer=" +
        this.selected.client_customer +
        "&process_status=" +
        this.selected.process_status +
        "&month=" +
        this.selected.month +
        "&year=" +
        this.selected.year
      );
    }
  },
  methods: {
    hideAuthorizationModal() {
      this.Modalauthorization = false;
    },
    sendEmail(process) {
      this.$swal
        .fire({
          title: "Se enviará informe de proceso. ¿Está seguro?",
          text: "",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#20a8d8",
          cancelButtonColor: "#f86c6b",
          cancelButtonText: "No",
          confirmButtonText: "Sí"
        })
        .then((result) => {
          if (result.value) {
            this.loading = true;
            this.$axios
              .get("/api/v1/process/" + process + "/send_email/")
              .then((res) => {
                var msg = res.data.msg;
                this.loading = false;
                miniToastr[res.data.color](msg, "");
                this.$refs["table"].refresh();
              })
              .catch((error) => {
                miniToastr.error(error, "");
                this.loading = false;
              });
          }
        });
    },
    getCompleteWaybill(a) {
      this.$refs.infoModalWaybill.show();
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_complete/")
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
    },
    async fetchData() {
      const response = await this.$axios.get(this.url);
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    showProcessModal(a, typeProcess) {
      if (typeProcess == 1) {
        //this.componenteActual='report';
        this.report = "report";
        this.loading = true;
        this.$nextTick(function () {
          this.getProcess(a);
        });

        this.$refs.infoModal.show();
      }

      if (typeProcess == 2) {
        this.componenteActual = "ReportRepaletizaje";
        this.loading = true;
        this.$nextTick(function () {
          this.getProcessRepa(a);
        });

        this.$refs.infoModalRepa.show();
      }
    },
    getProcess(process_id) {
      this.$axios
        .get("/api/v1/process/" + process_id + "/detailed_with_traceability/")
        // .then(x => new Promise(resolve => setTimeout(() => resolve(x), 2000)))
        .then((res) => {
          this.process = res.data;
          this.loading = false;
        })
        .catch((error) => console.log(error));
    },
    getProcessRepa(process_id) {
      this.tableDataPalletIn = [];
      this.tableDataMovimientos = [];

      this.$axios
        .get("/api/v1/process/" + process_id + "/process_detail_repaletizaje/")
        .then((res) => {
          this.tableDataPalletIn = res.data.movement_content;
          this.loading = false;

          const datos = res.data.movement_content;

          for (let key in datos) {
            var rowNew = {
              Pallet_entrada: datos[key].content.pallet_number,
              Pallet_salida: datos[key].content_reference.pallet_number,
              Producto: datos[key].content.product_name,
              Tipo_producto: datos[key].content.product_type_name,
              Variedad: datos[key].content.variety_name,
              origin: datos[key].content_reference.origin_name,
              kilos_brutos: datos[key].content.gross_kilograms,
              kilos_netos: datos[key].content.net_kilograms,
              Cantidad: datos[key].content.quantity,
              IDContenido: datos[key].content.id,
              container: datos[key].content_reference.container.name,
              condition: datos[key].content_reference.condition,
              variety: datos[key].content_reference.variety_name,
              creation_date: datos[key].content_reference.creation_date,
              plant: datos[key].content_reference.plant
            };

            this.tableDataMovimientos.push(rowNew);
          }
        })
        .catch((error) => console.log(error.message));
    },

    closeModal() {
      this.$refs.report.process = [];
      this.process = [];
      this.report = "";
    },
    status(process_status) {
      return process_status === 2
        ? "CERRADO"
        : process_status === 3
        ? "ENVIADO"
        : "ABIERTO";
    },
    getBadge(process_status) {
      return process_status === 2
        ? "dark"
        : process_status === 3
        ? "success"
        : "light";
    },
    getSelectionSet() {
      this.$axios
        .get("/api/v1/client/process_select_input/")
        .then((res) => {
          this.selectOptions.process_types = res.data.process_types;
          this.selectOptions.process_types.push({
            value: "",
            text: "-----------"
          });
          this.selectOptions.plants = res.data.plants;
          this.selectOptions.plants.push({ value: "", text: "-----------" });
          this.selectOptions.client_customers = res.data.client_customers;
          this.selectOptions.client_customers.push({
            value: "",
            text: "-----------"
          });
        })
        .catch((error) => console.log(error));
    },

    deleteWaybill(a, process_type_option) {
      if (process_type_option == 1) {
        miniToastr.info("Operación no permitida", "");
      }

      if (process_type_option == 2) {
        miniToastr.info("Operación no permitida", "");
      }
    },
    editProcess(obj) {
      if (obj.process_type.process_option == 2) {
        miniToastr.info("Opción de editar repaletizaje no disponible", "");
      }
      if (obj.process_type.process_option == 1) {
        this.$router.push(
          "/proceso/" +
            obj.process_type.process_option +
            "/" +
            obj.process_type.id +
            "/editar/" +
            obj.id
        );
      }
    },
    authorizationUser(obj, method) {
      this.currentObj = obj;
      this.Modalauthorization = true;
      this.methodDynamic = method;
    },
    loadYear() {
      for (let ano = 2019; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    },
    emailModal(obj) {
      if (obj.process_type.process_option == 1) {
        this.$axios({
          method: "get",
          url: "/reports/process_emails/" + obj.id
        })
          .then((res) => {
            miniToastr[res.data.color](res.data.msg, "");
            this.to = res.data.emails.to.join();
            this.cc = res.data.emails.cc.join();
            this.bcc = res.data.emails.bcc.join();
          })
          .catch((error) => {});
        this.process_id = obj.id;
        this.process_type_option = obj.process_type.process_option;
        this.subject = "Notificación de Proceso " + obj.number;
        this.$bvModal.show("email-modal");
      }

      if (obj.process_type.process_option == 2) {
        miniToastr.info("Opción no disponible", "");
      }
    }
  }
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
